import {
  Box,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightAddon,
  useToast
} from '@chakra-ui/react';
import { Button } from '../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import { api } from '../../../../services/api';
import { user } from '../../../../helpers/user';

async function propostaIsValid({ numeroProposta, codigoVendedor }) {
  const response = await api.get(`/site/v2/orcamento-crm/busca-proposta-vendedor`, {
    params: {
      numero_nota: numeroProposta,
      codigo_vendedor: codigoVendedor
    }
  });

  const { valida_proposta, numero_nota: numeroNota } = response.data;

  return {
    isValid: valida_proposta,
    numeroNota: numeroNota
  };
}

export function BuscarProposta() {
  const navigate = useNavigate();
  const inputRef = React.useRef(null);

  const toast = useToast({
    position: 'top-right',
    status: 'error',
    duration: 3000,
    isClosable: true
  });

  async function onSubmit(e) {
    e.preventDefault();

    const { isValid, numeroNota } = await propostaIsValid({
      numeroProposta: inputRef.current.value,
      codigoVendedor: user.codigo_vendedor
    });

    if (!isValid) return toast({ description: 'Proposta não encontrada' });

    const value = inputRef.current.value;

    if (!value) return toast({ description: 'Informe o número da proposta' });

    navigate(`/vendas/orcamento-pedido/${numeroNota}`);
  }

  return (
    <Box bg="white" minH="100vh" fontSize="12px" fontFamily="Open Sans">
      <Box
        maxW="1366px"
        w="full"
        mx="auto"
        px={4}
        pt={5}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column">
        <InputGroup maxW="400px" as="form" onSubmit={onSubmit}>
          <InputLeftAddon children="N. Proposta" fontSize="12px" />
          <Input borderRadius="0" ref={inputRef} />
          <InputRightAddon px={0}>
            <Button type="submit" colorScheme="blue" h="full" px={8} fontSize="12px">
              Buscar
            </Button>
          </InputRightAddon>
        </InputGroup>
      </Box>
    </Box>
  );
}
